import { render } from "./footerMarquee.vue?vue&type=template&id=c4fefdf0&scoped=true"
import script from "./footerMarquee.vue?vue&type=script&lang=js"
export * from "./footerMarquee.vue?vue&type=script&lang=js"

import "./footerMarquee.vue?vue&type=style&index=0&id=c4fefdf0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4fefdf0"]])

export default __exports__